import Image from "next/image";
import coverAbout from "/public/cover-about.svg";
import coverAboutTop from "/public/cover-aboutTop.svg";

const toccaText =
  "特化  / トッカ  / とっか / specialization / especialización / spécialisation /specializzazione / especialização / specialisatie / Spezialisierung / szakosodás / 전문화 / 专业化 / Специализация / uzmanlaşma / تخصص / التخصص / විශෂීකරණය / विशेषज्ञता / বিশেষীকরণ / chuyên môn hóa / ความเชี่ยวชาญ / faʻapitoa / spesialisasie / ubuchwepheshe / umwihariko / ជនញ / specialiĝo";

export const AboutCover = (props) => {
  return (
    <>
      <div className="mx-auto box-border flex aspect-1.91/1 max-h-[800px] flex-col items-center justify-center gap-2 bg-ter p-4 md:gap-6 md:py-8 md:px-10">
        <div className="relative z-0 flex aspect-2.193/1 w-full max-w-6xl items-center justify-center">
          <Image
            src={coverAbout}
            alt={toccaText}
            quality={50}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <h2 className="z-10 flex w-full max-w-6xl items-start justify-start text-left font-bold text-white fluid-text-[18px,32px]">
          About ToccaSystems
        </h2>
      </div>
    </>
  );
};

export const AboutCoverTop = (props) => {
  return (
    <>
      <div className="box-border flex aspect-3.18/1 flex-col items-center justify-center gap-2 bg-ter p-6 md:gap-6 md:py-8 md:px-10 lg:px-20">
        <div className="relative z-0 flex aspect-4.59/1 w-full max-w-7xl items-center justify-center">
          {/* <span className="block md:hidden">
            <Image
              src={coverAboutSQ}
              alt={toccaText}
              quality={50}
              layout="fill"
              objectFit="cover"
            />
          </span> */}
          <Image
            src={coverAboutTop}
            alt={toccaText}
            quality={50}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </>
  );
};
